var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineFilterSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.42 18.65c-.61-.34-.98-.96-.98-1.66v-3.08c0-.19-.15-.56-.3-.75l-2.17-2.28c-.41-.41-.72-1.13-.72-1.68V7.87c0-1.11.84-1.97 1.91-1.97h7.67c1.05 0 1.91.86 1.91 1.91v1.28c0 .7-.4 1.47-.8 1.87l-2.53 2.24c-.16.14-.33.49-.33.78v2.5c0 .63-.38 1.33-.89 1.63l-.79.51c-.31.19-.66.28-1.02.28-.33 0-.66-.08-.96-.25zM7.75 7.87V9.2c0 .13.14.47.3.63l2.22 2.34c.34.43.67 1.12.67 1.74v3.08c0 .2.13.31.21.35.11.06.29.1.45 0l.8-.52a.62.62 0 0 0 .18-.36v-2.5c0-.71.35-1.5.85-1.91l2.48-2.2c.13-.13.33-.53.33-.78V7.81c0-.22-.19-.41-.41-.41H8.16c-.24 0-.41.2-.41.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineFilterSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-filter-square.bd724998cd33e2dc046f443f5b369e91.svg";
export { ForwardRef as ReactComponent };